import React from 'react'
import { Button } from '@chakra-ui/react'
import { BoxProps, Text, Center } from '@chakra-ui/react'

interface Props extends BoxProps {
    isActive: boolean
    onClick: () => void
}

export default function ChipButton({
    isActive,
    onClick,
    children,
    ...rest
}: Props) {
    return (
        <Center
            onClick={onClick}
            as={Button}
            variant="unstyled"
            py={1}
            px={2}
            h="fit-content"
            borderColor={isActive ? 'brand.500' : 'gray.200'}
            bg={isActive ? 'brand.50' : 'gray.50'}
            color={isActive ? 'brand.800' : 'gray.700'}
            borderRadius="full"
            borderWidth="1px"
            minW="min-content"
            {...rest}
        >
            <Text
                fontSize="sm"
                fontWeight="semibold"
                whiteSpace="nowrap"
                color="inherit"
            >
                {children}
            </Text>
        </Center>
    )
}
